@import 'tailwindcss';

:root {
  color: #1c1917;
  background: #f7f4ef;
  font-family:
    Inter,
    ui-sans-serif,
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  min-width: 320px;
  min-height: 100vh;
  margin: 0;
}

button,
input,
textarea,
select {
  border-radius: 0;
  font: inherit;
}

button:focus-visible,
a:focus-visible,
input:focus-visible,
textarea:focus-visible,
select:focus-visible {
  outline: 3px solid #14b8a6;
  outline-offset: 2px;
}

::selection {
  color: #0f172a;
  background: #fde68a;
}

@media print {
  header,
  footer,
  nav,
  #idea,
  #research,
  #image,
  #audience,
  #settings,
  button,
  [role='tablist'] {
    display: none !important;
  }

  body,
  main,
  section,
  textarea {
    color: #111827 !important;
    background: #ffffff !important;
  }

  #draft,
  #exports {
    display: block !important;
    border: 0 !important;
  }

  textarea {
    min-height: auto !important;
    border: 0 !important;
    padding: 0 !important;
    white-space: pre-wrap;
  }
}
